import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    cursor: "pointer",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    ...shorthands.gap("12px"),
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.padding("12px"),
    ":nth-child(2)": {
      ...shorthands.borderRadius("4px"),
      ...shorthands.borderBottom("none"),
      ":not(:first-child):not(:last-child)": {
        ...shorthands.borderRadius("4px", "4px", "0px", "0px"),
      },
      ":nth-child(2) ~ :last-child": {
        ...shorthands.borderRadius("0px", "0px", "4px", "4px"),
      },
    },
    boxShadow: tokens.shadow4,
  },
  details: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    width: "100vw",
    ...shorthands.overflow("auto"),
  },
  icon: {
    width: "24px",
    height: "24px",
  },
  favIcon: {
    width: "19px",
    height: "24px",
    cursor: "pointer",
  },
  text: {
    fontFamily: tokens.fontFamilyBase,
    fontSize: tokens.fontSizeBase400,
    fontStyle: "normal",
    fontWeight: tokens.fontWeightSemibold,
    ...shorthands.overflow("hidden"),
    maxWidth: "calc(100vw - 48px)",
  },
});
